const GET_GL_ACCOUNT_CODES = 'GET_GL_ACCOUNT_CODES'
const SET_GL_ACCOUNT_CODES = 'SET_GL_ACCOUNT_CODES'

const GET_GL_ACCOUNT_CODE_SAVE = 'GET_GL_ACCOUNT_CODE_SAVE'
const SET_GL_ACCOUNT_CODE_SAVE = 'SET_GL_ACCOUNT_CODE_SAVE'

export {
    GET_GL_ACCOUNT_CODES,
    SET_GL_ACCOUNT_CODES,
    GET_GL_ACCOUNT_CODE_SAVE,
    SET_GL_ACCOUNT_CODE_SAVE
}
